import { gql } from "@apollo/client";

export const GET_ASSIGNMENTS=gql`
query getAllUploadedAssignments($input: getUploadAssignmentInput!) {
  getAllUploadedAssignments(input: $input) {
    datas {
      fileId
      filename
      filepath
      filesize
      filetype
      isClassroom
      feedId
    }
    totalCount
  }
}`;

export const UPLOAD_ASSIGNMENT=gql`
mutation addAssignment($cId: UUID!, $filename: String!, $filepath: String!, $filesize: BigInt!, $isClassRoom: Boolean!, $filetype: String = null, $sjId: UUID!) {
  addAssignment(
    input: {pClassroomId: $cId, pFilename: $filename, pFilepath: $filepath, pFilesize: $filesize, pFiletype: $filetype, pIsClassroom: $isClassRoom, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;

export const UPDATE_ASSIGNMENT = gql`
mutation updateUploadedAssignmentMaterials($cId: UUID!, $fId: UUID!, $isClassroom: Boolean!, $sjId: UUID!) {
  updateUploadedAssignmentMaterials(
    input: {pClassroomId: $cId, pIsClassroom: $isClassroom, pFileId: $fId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;

export const DELETE_ASSIGNMENT = gql`
mutation deleteUploadedAssignments($cId: UUID!, $fId: UUID!,$sjId: UUID!) {
  deleteUploadedAssignments(
    input: {pClassroomId: $cId, pFileId: $fId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;

export const SUBMIT_ASSIGNMENT = gql`
mutation submitAssignment($input: submitAssignmentInput!) {
  submitAssignment(input: $input)
}`;

export const GET_ALL_SUBMITTED_ASSIGNMENTS= gql`
query getSubmittedAssignments($input: getUploadAssignmentInput = {cId: "", sjId: ""}) {
  getSubmittedAssignments(input: $input) {
    datas {
      fileId
      filename
      filepath
      filesize
      filetype
      isClassroom
      isExpiry
    }
    totalCount
  }
}`;

export const UPDATE_SUBMITTED_ASSIGNMENTS = gql`
mutation updateSubmittedAssignmentMaterials($cId: UUID!, $sjId: UUID!, $fId: UUID!, $isClassroom: Boolean!) {
  updateSubmittedAssignmentMaterials(
    input: {pClassroomId: $cId, pFileId: $fId, pIsClassroom: $isClassroom, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}
`;

export const DELETE_SUBMITTED_ASSIGNMENTS = gql`
mutation deleteSubmittedAssignmentMaterials($cId: UUID!, $sjId: UUID!, $fId: UUID!) {
  deleteSubmittedAssignmentMaterials(
    input: {pClassroomId: $cId, pFileId: $fId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}
`;

export const STUDENTS_LIST_FOR_ASSIGNMENTS = gql`
query getSubmittedAssignmentsWithStudentDetails($cId: UUID!, $sjId: UUID!, $limit: Int = null, $offset: Int = null) {
  getSubmittedAssignmentsWithStudentDetails(
    pClassroomId: $cId
    pSubjectId: $sjId
    first: $limit
    offset: $offset
  ) {
    nodes {
      studentId
      studentName
      studentAvatarUrl
    }
    totalCount
  }
}`;

export const GET_ASSIGNMENT_EXPIRY_TIME = gql`
  query getAssignmentExpiryTime($cId: String!, $sjId: String!) {
    getAssignmentExpiryTime(cId: $cId, sjId: $sjId) {
      hours
      minutes
    }
  }
`;

export const SET_ASSIGNMENT_EXPIRY_TIME = gql`
  mutation setAssignmentExpiryTime($cId: String!, $expiryHours: Int!, $expiryMinutes: Int!, $sjId: String!) {
    setAssignmentExpiryTime(cId: $cId, expiryHours: $expiryHours, expiryMinutes: $expiryMinutes, sjId: $sjId)
  }
`;
